<h1 class="strong" mat-dialog-title>
  {{ 'header.timesheetSettings' | translate }}
</h1>
<div class="timesheet-settings-dialog-content" mat-dialog-content>
  <div class="timesheet-settings-dialog-content__reset">
    <button class="btn btn-withIcon btn-secondary" [disabled]="isLoading$ | async" (click)="reset()">
      <span class="icon icon-Reset"></span>
      <span>{{ 'header.settingsMenu.timesheetSettings.resetSettings' | translate }}</span>
    </button>
  </div>
  @if ((isLoading$ | async) === false) {
    <app-universal-dropdown
      class="timesheet-settings-dialog-content__page-dropdown"
      [formControl]="timesheetSettingsForm.get('pageSize') | formControl"
      [options]="timesheetPageOptions"
      label="header.settingsMenu.timesheetSettings.pageSize"
      placeholder="header.settingsMenu.timesheetSettings.pageSize"
    ></app-universal-dropdown>
    <mat-checkbox [ngModel]="showProjectNumberColumnInTimesheets" (change)="onClickNumberColumn($event)">{{
      'timesheets.buttons.showIdColumn' | translate
    }}</mat-checkbox>
  } @else {
    <app-loading [loadingMode]="LoadingMode.OVERLAY"></app-loading>
  }
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeDialog()">
    {{ 'default.close' | translate }}
  </button>
  <button class="btn btn-primary" [disabled]="isLoading$ | async" (click)="save()">
    {{ 'default.apply' | translate }}
  </button>
</div>
